import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { Environment } from '@iot-platform/models/common';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChartAxisPoint } from '../models/chart-axis-point.model';

@Injectable({ providedIn: 'root' })
export class ChartService {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient: HttpClient = inject(HttpClient);

  getCylinderRssiPoints(id: string, start?: Moment, end?: Moment): Observable<ChartAxisPoint[]> {
    let url = `${this.environment.api.url}${this.environment.api.endpoints.assets}/messages/rssi-history?identifier=${id}`;
    if (start) {
      url = `${url}&start=${start.toISOString()}`;
    }
    if (end) {
      url = `${url}&end=${end.toISOString()}`;
    }
    return this.httpClient
      .get(url)
      .pipe(
        map((result: { [key: string]: number }) =>
          Object.entries(result).reduce((acc, [dateTime, rssi]) => [...acc, { x: moment(dateTime).valueOf(), y: rssi }], [])
        )
      );
  }

  getReceiverRssiPoints(id: string, start?: Moment, end?: Moment): Observable<ChartAxisPoint[]> {
    let url = `${this.environment.api.url}${this.environment.api.endpoints.receivers}/messages/rssi-distribution?forwarderEui=${id}`;
    if (start) {
      url = `${url}&start=${start.toISOString()}`;
    }
    if (end) {
      url = `${url}&end=${end.toISOString()}`;
    }
    return this.httpClient
      .get(url)
      .pipe(
        map((result: { [key: string]: number }) =>
          Object.entries(result).reduce((acc, [rssi, messageCount]) => [...acc, { x: Number(rssi), y: messageCount }], [])
        )
      );
  }
}
